import { createSelector } from 'reselect';

const selectStores = (state: any) => state.stores;


export const selectStoresCurrentItem = createSelector([selectStores], (stores) => stores.current);

export const selectStoresListItems = createSelector([selectStores], (stores) => stores.list);

export const selectStoresItemById = (itemId: any) =>
    createSelector(selectStoresListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectStoresQueryItems = createSelector([selectStores], (stores) => stores.query);

export const selectStoresCreatedItem = createSelector([selectStores], (stores) => stores.create);

export const selectStoresUpdatedItem = createSelector([selectStores], (stores) => stores.update);

export const selectStoresReadItem = createSelector([selectStores], (stores) => stores.read);

export const selectStoresDeletedItem = createSelector([selectStores], (stores) => stores.delete);

export const selectStoresSearchedItems = createSelector([selectStores], (stores) => stores.search);

export const selectStoresItemsCount = createSelector([selectStores], (stores) => stores.count);

export const selectStoresItemsFilter = createSelector([selectStores], (stores) => stores.filter);